import React, { useState, useEffect } from "react";
import styles from "./PortfolioBlock.module.css";
import Modal from "../../PortfolioModal/modal";
import { useDispatch } from "react-redux";
import { setDisableHeader } from "../../../../../app/features/userSlice";
import { FaTrash, FaEdit } from "react-icons/fa"; // Example icons

function PortfolioBlock({ id, title, description, role, media, setEditItem, media2, media3, onRemove, media4, media5, onEdit }) {
    const allMedia = [media, media2, media3, media4, media5].filter(Boolean); // Filter valid media
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [colors, setColors] = useState({ primary: null, secondary: null }); // State for colors
    const dispatch = useDispatch();

    const handleModalToggle = () => {
        dispatch(setDisableHeader(!isModalOpen));
        setIsModalOpen(!isModalOpen);
    };

    const extractColors = (imageUrl) => {
        const imgElement = new Image();
        imgElement.crossOrigin = "Anonymous"; // Required for accessing image pixels
        imgElement.src = imageUrl;

        imgElement.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = imgElement.width;
            canvas.height = imgElement.height;
            ctx.drawImage(imgElement, 0, 0);

            const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

            let r = 0, g = 0, b = 0;
            let totalPixels = pixels.length / 4; // 4 channels per pixel (RGBA)

            for (let i = 0; i < pixels.length; i += 4) {
                r += pixels[i];
                g += pixels[i + 1];
                b += pixels[i + 2];
            }

            const avgColor = {
                r: Math.floor(r / totalPixels),
                g: Math.floor(g / totalPixels),
                b: Math.floor(b / totalPixels),
            };

            const primary = `rgb(${avgColor.r}, ${avgColor.g}, ${avgColor.b})`;
            const secondary = `rgb(${Math.min(255, avgColor.r + 50)}, ${Math.min(255, avgColor.g + 50)}, ${Math.min(255, avgColor.b + 50)})`;
            if (colors.primary !== primary || colors.secondary !== secondary) {
                setColors({ primary, secondary });
            }
        };
    };

    useEffect(() => {
        if (allMedia[0]) {
            const imageUrl = allMedia[0]?.type?.startsWith("image")
                ? URL.createObjectURL(allMedia[0])
                : `${process.env.REACT_APP_UPLOADS_PATH}${allMedia[0]}`;

            extractColors(imageUrl);
        }
    }, [allMedia]);
    return (
        <div>
            <div
                className={styles.portfolioBox}
                onClick={handleModalToggle}
                style={{
                    background: `linear-gradient(to top, ${colors.secondary}, ${colors.primary})`,
                }}
            >
                <div className={styles.backgroundBlur}></div>
                <div className={styles.foregroundContent}>

                    {allMedia[0] && allMedia[0]?.type?.startsWith("image") ? (
                        <img
                            src={URL.createObjectURL(allMedia[0])}
                            alt={title}
                            className={styles.image}
                        />
                    ) : (
                        <img
                            className={styles.image}
                            src={`${process.env.REACT_APP_UPLOADS_PATH}${allMedia[0]}`}
                            alt={`portfolio images`}
                        />
                    )}
                    <div
                        className={onRemove ? styles.overlay : styles.overlay2}
                        style={{}} // Apply secondary color as text color
                    >
                        {onRemove && (
                            <div className={styles.icons}>
                                <FaEdit
                                    className={styles.editIcon}
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent modal from opening
                                        if (onEdit) {
                                            setEditItem({ id, title, description, role, media, media2, media3, media4, media5 });
                                            onEdit({ id, title, description, role, media, media2, media3, media4, media5 });
                                        }
                                    }}
                                />
                                <FaTrash
                                    className={styles.deleteIcon}
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent modal from opening
                                        onRemove(id);
                                    }}
                                />
                            </div>
                        )}
                        <h3 className={styles.title}>{title}</h3>
                    </div>
                </div>


            </div>
            {
                isModalOpen && (
                    <Modal onClose={handleModalToggle}>
                        <div className={styles.modalContent}>
                            <h2 className={styles.modalTitle}>{title}</h2>
                            <p className={styles.modalDesciption} style={{margin:0}}>{description}</p>
                            <p className={styles.modalDesciption}>{role}</p>
                            <div className={styles.imageGallery}>
                                {allMedia.map((image, index) =>
                                    image.type?.startsWith("image") ? (
                                        <img
                                            key={index}
                                            src={URL.createObjectURL(image)}
                                            alt={title}
                                            className={styles.modalImage}
                                        />
                                    ) : (
                                        <img
                                            key={index}
                                            className={styles.modalImage}
                                            src={`${process.env.REACT_APP_UPLOADS_PATH}${image}`}
                                            alt={`portfolio images`}
                                        />
                                    )
                                )}
                            </div>
                        </div>
                    </Modal>
                )
            }
        </div >
    );
}

export default PortfolioBlock;
